module.exports = __webpack_public_path__ + "img/closeCycle.993460b2.png";